<div class="bp-modal mod-lg" [class.elevated]="isWalletStackSelection()">
  @if (!summary) {
    <!-- Regular SEND flow (initial selection + cryptocoin send)-->
    @if (!paymentsFlow) {
      @if (currentStep; as header) {
        <bp-modal-header
          class="font-semibold"
          [title]="header.title"
          [showIndicator]="!isFourthStep && !isVerificationMandatory()">
          @if (header.left; as left) {
            <a
              left
              (click)="onHeaderButtonClick(left)"
              (keydown.enter)="onHeaderButtonClick(left)"
              [tabIndex]="0">
              {{ left | translate }}
            </a>
          }
          @if (header.right; as right) {
            <a
              right
              (click)="onHeaderButtonClick(right)"
              (keydown.enter)="onHeaderButtonClick(right)"
              [tabIndex]="0">
              {{ right | translate }}
            </a>
          }
        </bp-modal-header>
      }
      <div class="bp-modal-body">
        <div
          class="bp-modal-body-section"
					[ngClass]="{
						'mod-fullwidth': isSecondStep,
						'pb-0': isThirdStep,
						'pb-0 pt-0 pl-0 pr-0': isTradableListSelection() && !isVerificationMandatory(),
						'mod-white pt-10 pb-10': isFourthStep
					}">
          @if (isFirstStep) {
            @if (!isVerificationMandatory()) {
              @if (hasWallets()) {
                @if (isWalletStackSelection()) {
                  <div class="bp-modal-description">
                    {{ "tradable_wallet_selection_stack_send" | translate }}
                  </div>
                }
                @if (isFirstStep) {
                  <tradable-list-item
                    [(tradableId)]="tradableId"
                    [action]="'send'"
                    [fiatWallets]="getSendFiatWallets$ | async"
                    [tradables]="cryptocoinItems"
                    [isMultichain]="isMultichain$ | async"
                    (onFiatSelect)="startPaymentsFlow($event)"
                    (onSelect)="selectWallet($event)"
                    (onSelectMultichainTradable)="resetData()"
                  (onRefresh)="doTrapFocusTime()"></tradable-list-item>
                }
              } @else {
                <empty
                  class="hover-pointer text-green"
                  (click)="buyRedirect()"
                  [headline]="'no_wallets_headline' | translate"
                text="no_wallets_with_balance_send_modal"></empty>
              }
            } @else {
              <verification-start></verification-start>
            }
          }
          @if (isSecondStep) {
            <sending-recipient
              (onSelectRecipient)="recipientAdded($event)"
              [wallet]="wallet">
            </sending-recipient>
          }
          @if (isThirdStep) {
            <div>
              <div class="text-center pb-20 text-summary-description">
                {{ "send_description_three" | translate: [item.getName()] }}
              </div>
              <div class="modal-grid mod-three-cols">
                @for (amount of getAmounts(); track amount) {
                  <tradable-amount-tile
                    [ngClass]="'grid-item'"
                    (click)="setSendAmount(amount)"
                    [fiat]="fiat"
                    [conversion]="amount"
                    [tradable]="item"
                    (keydown.enter)="setSendAmount(amount)">
                  </tradable-amount-tile>
                }
                <tradable-amount-tile
                  [ngClass]="'grid-item'"
                  (click)="setSendMaxAmount()"
                  [conversion]="maxAmount()"
                  [all]="true"
                  [fiat]="fiat"
                  [tradable]="item"
                  (keydown.enter)="setSendMaxAmount()">
                </tradable-amount-tile>
              </div>
            </div>
          }
        </div>
        <!-- Select Amount -->
        @if (isThirdStep) {
          <div class="bp-modal-body-section mod-fullwidth pt-30">
            <!-- Input field-->
            <div class="items-start flex-wrap modal-internal-transfer mod-input">
              @if (show) {
                <bp-input
                  iconLeading="true"
                  [type]="getInputFormat()"
                  class="mod-input-line"
                  [iconUrl]="icon"
                  [iconUrlAltText]="'logo_alt_text' | translate"
                  min="0"
                  name="amount_fiat"
                  [step]="getStepsFromOfferFiat()"
                  (onKeyEnter)="gotoSummary()"
                  required
                  autofocus
                  [(value)]="amount"
                  [error]="amountError | translate"
                  (inputChange)="clearErrorMessage()"
                  [formGroupClass]="false"
                  (onFocus)="inputOnFocus($event)">
                  <a right (click)="change('swap')" class="hover-pointer color-text" href="javascript:">
                    <span
									[ngClass]="{
										'text-transparent font-size-13': userWants !== 'cryptocoin',
										'text-highlight font-size-17': userWants === 'cryptocoin'
									}">
                      {{ item?.getSymbol() }}
                    </span>
                    @if (!checkZeroPrecision()) {
                      <span>
                        &nbsp;/&nbsp;
                        <span
										[ngClass]="{
											'text-transparent font-size-13': userWants !== 'fiat',
											'text-highlight font-size-17': userWants !== 'cryptocoin'
										}">
                          {{ fiat?.getSymbol() }}
                        </span>
                      </span>
                    }
                  </a>
                </bp-input>
              }
            </div>
            <!-- Minimum / Equivalent labels + fees info -->
            <div class="bp-modal-row mt-10 bp-modal-custom-margin modal-internal-transfer mod-input">
              <div class="bp-modal-column left">
                @if (walletBalance.balance?.operationalBalance < walletBalance.balance?.balance) {
                  <div>
                    <span [class.error]="amountInvalidMax">
                      {{
                      "available_send_balance"
                      | translate
                      : [
                      walletBalance.balance?.operationalBalance
                      | tradable_precision_symbol
                      : { id: item?.getId(), ignorePrecision: true }
                      ]
                      }}
                    </span>
                    <span
                      [bp-tooltip]="'recent_deposit_disclaimer' | translate"
                      class="no-ul"
                      position="top">
                      <i class="bpi__icon-info-inverted"></i>
                    </span>
                  </div>
                }
                @if (checkZeroPrecision()) {
                  <div>
                    {{ "minimum" | translate }}: 1 {{ item?.getSymbol() }}
                  </div>
                } @else {
                  <div>
                    {{ "minimum" | translate }}:
                    {{
                    min() | tradable_precision_symbol: { id: item?.getId(), ignorePrecision: true }
                    }}
                  </div>
                }
                @if (!data?.transaction?.isInternalSendType()) {
                  <span class="block">
                    {{ "fee" | translate }}
                    <a [href]="getSendModalToolTipLink('fee')" [target]="'_blank'">
                      <span
                        [bp-tooltip]="'send_modal_amount_tooltip' | translate"
                        position="top"
                      class="bpi__icon-info color-primary"></span>
                    </a>
                    {{
                    getFeeAmount()
                    | tradable_precision
                    : {
                    id: item?.getId(),
                    ignorePrecision: true,
                    symbol: true,
                    currencies: [item]
                  }
                  }}
                  {{ item?.getSymbol() }} &asymp;&nbsp;{{
                  feeAmountFiat
                  | fiat_precision_symbol
                  : {
                  id: fiat?.getId(),
                  prefix: feeAmountFiat < 0.01,
                  symbol: true,
                  currencies: [fiat]
                }
                }}
              </span>
            }
          </div>
          <div class="bp-modal-column right text-gray">
            1 {{ item?.getSymbol() }} &asymp;&nbsp;{{
            price?.getPrice()?.getFiat()
            | fiat_precision_symbol
            : { id: fiat?.getId(), currencies: [fiat, item], symbol: true }
            }}
          </div>
        </div>
        @if (isBitpandaAddress()) {
          <hr class="mb-20" />
        }
        @if (onlyInternalSending()) {
          <div class="mt-10 mb-10 text-center text-small-gray">
            {{ "withdraw_can_only_be_sent_internal" | translate }}
          </div>
        }
        @if (onlyExternalSending()) {
          <div class="mt-10 mb-10 text-center text-small-gray">
            {{ "withdraw_can_only_be_sent_external" | translate }}
          </div>
        }
        @if (showLowFundsWarning()) {
          <div class="mt-10 mb-10 text-center text-small-gray">
            {{ "withdraw_not_enough_funds_for_external_send" | translate }}
          </div>
        }
        <!-- Internal transfer switch On/Off -->
        @if (showInternalTransferSlider()) {
          <div class="container-left-right modal-internal-transfer">
            <div>
              <div class="pb-5">
                <label class="placeholder" for="send-internal">
                  <span class="large-weight">{{ "send_as_internal_transaction" | translate }}</span>
                </label>
                <a [href]="getSendModalToolTipLink('switchSend')" [target]="'_blank'">
                  <span
                    [bp-tooltip]="'send_modal_amount_tooltip' | translate"
                  class="bpi__icon-info"></span>
                </a>
              </div>
              <div class="text-opaque">{{ "details_internal" | translate }}</div>
            </div>
            <div>
              <div class="form-on-off-switch mod-green">
                <input
                  type="checkbox"
                  name="onoffswitch"
                  (change)="toggleSendType()"
                  id="send-internal"
                  [(ngModel)]="data.transaction._try_internal"
                  class="form-on-off-switch-checkbox" />
                <label class="form-on-off-switch-label" for="send-internal">
                  <span class="form-on-off-switch-inner"></span>
                  <span class="form-on-off-switch-switch"></span>
                </label>
              </div>
            </div>
          </div>
        }
        <hr class="mb-20 mt-30" />
        <!-- Total amount / equivalent -->
        <div class="pl-50 pr-50">
          <div class="bp-modal-row font-size-24" [ngClass]="{ 'text-light': !hasSuffFunds }">
            <div class="bp-modal-column left mr-5">{{ "amount_total" | translate }}</div>
            <div class="bp-modal-column right break">
              <strong>
                {{
                amountItemTotal()
                | tradable_precision
                : {
                id: item?.getId(),
                currencies: [item],
                txPrecision: getTxPrecision(),
                ignorePrecision: data?.transaction?.isInternalSendType()
              }
              }}
            </strong>
            {{ item?.getSymbol() }}
          </div>
        </div>
        <div class="bp-modal-row font-size-15">
          <div class="bp-modal-column left mr-5">
            @if (getFeeAmount() > 0) {
              {{ "inkl_fees_translation" | translate }}
            }
          </div>
          <div class="bp-modal-column right break">
            &asymp;
            {{
            multiplyTradableAmountByFiatPrice
            | fiat_precision_symbol
            : {
            id: fiat.getId(),
            currencies: [fiat],
            notPrice: true,
            symbol: true
          }
          }}
          @if (
            !data?.transaction._try_internal && min() < multiplyTradableAmountByFiatPrice
            ) {
            plus &asymp;
            {{
            feeAmountFiat
            | fiat_precision_symbol
            : { id: fiat?.getId(), currencies: [fiat, item], symbol: true }
            }}
            {{ "fees" | translate | lowercase }}
          }
        </div>
      </div>
    </div>
    <!-- 'Go To Summary' button -->
    <div class="pl-30 pr-30 mt-20 text-center">
      <button
        class="btn btn-primary btn-lg btn-summary mod-amount"
        type="button"
        (click)="gotoSummary()">
        {{ "goto_summary_send_button" | translate }}
      </button>
    </div>
  </div>
}
</div>
<!-- Extra warning for external addresses -->
@if (isFourthStep) {
  <div>
    <!-- Text box & terms slider -->
    <div class="pl-70 pr-70 text-center">
      <!-- Subtitle -->
      <div class="mb-20">{{ "send_warning_message_subtitle" | translate }}</div>
      <!-- Orange box -->
      <div class="warning-box mod-orange text-left">
        <div class="font-semibold font-size-14 mb-20">
          {{ "send_warning_message_box_title" | translate }}
        </div>
        <!-- Item with icon + text + link -->
        @for (item of getWarningItems(); track item) {
          <div class="flex flex-row mb-10">
            <div class="items-center mr-10">
              <span class="bpi__icon-check-circle success-icon-small"></span>
            </div>
            <div class="font-size-14">
              {{ "send_warning_message_box_item_" + item | translate }}
              @if (item === 3) {
                <a [href]="getWarningScamsUrl()" target="_blank">
                  {{ "send_warning_message_box_item_" + item + "_link" | translate }}
                </a>
                {{ "send_warning_message_box_item_" + item + "_info" | translate }}
              }
            </div>
          </div>
        }
      </div>
      <!-- Slider -->
      <bp-switch [model]="warningSlider" field="terms">
        <div left>
          <span class="text-medium-black large-weight">
            {{ "send_warning_message_confirm_terms" | translate }}
          </span>
        </div>
      </bp-switch>
    </div>
    <!-- Button -->
    <hr class="mb-20 mt-30" />
    <div class="pl-30 pr-30 mt-20 mb-20 text-center">
      <button
        class="btn btn-primary btn-lg btn-summary mod-amount"
        type="button"
        (click)="onWarningAccept()"
        [ngClass]="{ disabled: !warningSlider.terms }">
        {{ "Continue" | translate }}
      </button>
    </div>
  </div>
}
} @else {
  <fiat-send
    [data]="{ transaction: fiatTx }"
    (onAbort)="resetPaymentsFlow()"
    (onSuccess)="paymentsFlowSuccess = true">
  </fiat-send>
}
<!-- PAYMENTS - FIAT send flow -->
} @else {
  <send-summary
    [fee]="getFeeAmount()"
    [data]="data.transaction"
    (onClose)="close()"
    (edit)="setEdit($event)"
    (finish)="showSuccessScreen($event)"
  [needsZeroPrecision]="checkZeroPrecision()"></send-summary>
}
</div>
